<template>
  <div class="animated fadeIn">
    <Forms
      ref="frmGroup"
      :title="'CADASTRO DE VALOR DO KM - FOLLOWUP'"
      :showClearButton="true"
      :showSaveButton="true"
      :showBackButton="true"
      v-on:Clear="onClear"
      v-on:Back="onBack"
      v-on:Save="onSave"
    >
      <div class="form-group row">
        <div class="col-md-9 pt-2">
          <label>
            <small
              v-show="form.tipoTransporte.required"
              class="text-danger"
            >
              *
            </small>
            Tipo de transporte:
          </label>
          <div class="input-group">
            <b-form-input
              type="text"
              :placeholder="'Digite o tipo de transporte'"
              v-model="form.tipoTransporte.value"
              :size="form.tipoTransporte.maxlength"
              :required="form.tipoTransporte.required"
              :state="form.tipoTransporte.state"
            ></b-form-input>
          </div>
        </div>

        <div class="col-md-3 pt-2">
          <label>
            <small
              v-show="form.valor.required"
              class="text-danger"
            >
              *
            </small>
            Valor do Km:
          </label>
          <div class="input-group">
            <money
              id="valor-despesa"
              :placeholder="$lang.Currency.Placeholder"
              class="form-control text-bold"
              max-length="12"
              :value="form.valor.value"
              v-model.lazy="form.valor.value"
              v-bind="$lang.Currency.Format"
            />
          </div>
        </div>
      </div>
    </Forms>

    <HistoryTable :options="historyTable" />
  </div>
</template>

<script>
import Tools from '@/components/tools/Tools.js'
import { advancedOnException } from '@/components/tools/Utils'
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading, toast } from '@/shared/utils/UIHelper'

import KmValueRepository from '@/shared/http/repositories/configurations/kmvalue.js'
import KmValueModel from '@/shared/models/configurations/kmvaluemodel.js'
import kmValueForm from './kmValue-form.js'

import HistoryTable from '@/views/private/configurations/visitas/kmValue/components/add/historyTable/HistoryTable.vue'

export default {
  name: 'kmValueAdd',
  mixins: [ActionsForm],
  data () {
    return {
      data: KmValueModel,
      form: kmValueForm,
      historyTable: []
    }
  },
  components: {
    HistoryTable
  },
  methods: {
    onBack () {
      this.$emit('Back')
    },
    onLoad () {
      this.onClear()
    },
    onEdit (obj) {
      loading.push()

      if (obj) {
        Tools.SetValueInForm(this.form, this.data, obj)
        this.historyTable = obj.historicoValorKm
      }

      loading.pop()
    },
    onClear () {
      this.data.id = null
      this.form.valor.value = 0
      this.form.tipoTransporte.value = ''
    },
    onCreate () {
      loading.push()

      KmValueRepository.Create(this.data)
        .then((response) => {
          loading.close()
          this.$emit('Back')
          toast.success(this.$lang.Common.Alerts.Success)
        })
        .catch((error) => advancedOnException(error, this.$lang))
      loading.close()
    },
    onUpdate () {
      loading.push()

      this.data.id = parseInt(this.data.id)
      KmValueRepository.Update(this.data)
        .then((response) => {
          loading.close()
          this.$emit('Back')
          toast.success(this.$lang.Common.Alerts.Success)
        })
        .catch((error) => advancedOnException(error, this.$lang))
      loading.close()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/visitas/kmValue/components/add/kmValueAdd.vue